import React from "react";
import { Routes, Route } from "react-router-dom";
import App from '../App'
import PaymentResult from "../modules/MICustomer/components/PaymentResult";
import MainCustomerPortal from "../modules/MICustomer/views/Main";
import FullMemberDetails from "../modules/MICustomer/components/FullMemberDetails";
import Customerquote from '../modules/MICustomer/views/customerquote' 
import ComplaintMaster from '../modules/ComplaintsAndFeedback/views/ComplaintMaster' 
// import CommunicationModuleSearch from "../modules/communicationmodule/components/CommunicationModuleSearch";
import UserEntry from "../modules/communicationmodule/views/userentry";
import GetQuoteOnlineDetails from "../modules/communicationmodule/views/GetQuoteOnlineDetails";
import WhistleBlowing from "../modules/ComplaintsAndFeedback/views/WhistleBlowingMaster";

var routes = (
  <App>
    <Routes>
      <Route path="/paymentresult" element={<PaymentResult />} />
      <Route path="/customerportal" element={<MainCustomerPortal />} />
      <Route path="/fullMemberDetails/:id?" element={<FullMemberDetails />} />
      <Route path="/quote" element={<Customerquote />} />
      <Route path="/complaintsandFeedback" element={<ComplaintMaster />} />
      <Route path="/whistleBlowing" element={<WhistleBlowing />} />
      
            {/* <Route path="/communicationMaster" element={<CommunicationModuleSearch />} /> */}
      <Route path="/userentry" element={<UserEntry />} />
      <Route path="/getquoteonline" element={<GetQuoteOnlineDetails />} />
    </Routes>
  </App>
);



export default routes;